export default "__VITE_ASSET__Cr3tYur4__"